/**
 * Manages a dynamic CollectionPage JSON-LD <script> tag in <head>.
 *
 * The schema is injected only when a named playlist/favorites page is shown,
 * i.e. searchType === "favorites" && playlistName is a non-empty string.
 * Matches the condition under which the "Playlist-name-container" element
 * is populated (src/client/Search.js).
 */

const SCRIPT_ID = "as-collectionpage-schema";

/**
 * Build the CollectionPage JSON-LD object for a named playlist.
 * @param {string} playlistName
 * @returns {object}
 */
function buildCollectionPageSchema(playlistName) {
  return {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: playlistName,
    url: window.location.href.split("#")[0],
  };
}

/**
 * Update or remove the CollectionPage JSON-LD block based on current state.
 * @param {{ searchType: string, playlistName: string | null }} state
 */
export function updateCollectionPageSchema(state) {
  const existing = document.getElementById(SCRIPT_ID);

  const shouldShow =
    state.searchType === "favorites" &&
    typeof state.playlistName === "string" &&
    state.playlistName.length > 0;

  if (!shouldShow) {
    if (existing) {
      existing.remove();
    }
    return;
  }

  const schema = buildCollectionPageSchema(state.playlistName);
  const json = JSON.stringify(schema);

  let script = existing;
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = SCRIPT_ID;
    document.head.appendChild(script);
  }
  script.textContent = json;
}
